import { LoginPage } from "../pages/loginPage";
import { ForgotPasswordPage } from "../pages/forgotPasswordPage";
import { ResetPasswordPage } from "../pages/resetPasswordPage";
import { NewPassword } from "../pages/newPassword";
import { ResendWelcomeEmailPage } from "../pages/resendWelcomeEmailPage";
import { SendAssessmentValidationEmailPage } from "../pages/sendAssessmentValidationEmailPage";
import { ParticipantUpdateEmailPage } from "../pages/participantUpdateEmailPage";
import { HelpCenter } from "../../participant/pages/participantHelpCenterPage";

export const authRoutes = [
  {
    path: "/",
    Component: LoginPage,
    exact: true,
    isPrivate: false,
  },
  {
    path: "/recover",
    Component: ForgotPasswordPage,
    exact: false,
    isPrivate: false,
  },
  {
    path: "/reset-password",
    Component: ResetPasswordPage,
    exact: false,
    isPrivate: false,
  },
  {
    path: "/new-password",
    Component: NewPassword,
    exact: false,
    isPrivate: false,
  },
  {
    path: "/send-welcome",
    Component: ResendWelcomeEmailPage,
    exact: false,
    isPrivate: false,
  },
  {
    path: "/send-verify-code",
    Component: SendAssessmentValidationEmailPage,
    exact: false,
    isPrivate: false,
  },
  {
    path: "/participant-update-email",
    Component: ParticipantUpdateEmailPage,
    exact: false,
    isPrivate: false,
  },
  {
    path: "/help",
    Component: HelpCenter,
    exact: false,
    isPrivate: false,
  },
];
